import axios from "@/utils/request";
import { snkd } from "@/api/api";
import { getStorage } from "@/utils/storage";

const { companyId, farmId } = getStorage("FARMINFO");

// 农场查供应商
export const getSupplierInfo = () => {
  return axios.post(snkd.purchase.supplier.get, {
    companyId,
    farmId,
  });
};

export const getWxQrCode = (params = {}) => {
  return axios.post(snkd.purchase.supplier.getWxQrCode, {
    farmId,
    ...params,
  });
};

export const getPurchaserList = (params = {}) => {
  return axios.post(snkd.purchase.supplier.getPagePurchase, {
    farmId,
    ...params,
  });
};

export const getPurchasDetail = (params = {}) => {
  return axios.post(snkd.purchase.supplier.getPurchaseById, {
    farmId,
    ...params,
  });
};
